// @ts-strict-ignore
import {Component, Injector, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {FormArray, FormControl, Validators} from "@angular/forms";
import {Scenario} from "@models";

export interface DialogData_ChangeScenarioDialogInput extends MatDialogDataBaseInput {
	scenario: Scenario;
}

export interface DialogData_ChangeScenarioDialogOutput extends MatDialogDataBaseOutput {
	newScenario?: Scenario;
}

@Component({
	selector: "sim-change-scenario-dialog",
	templateUrl: "./change-scenario-dialog.component.html",
	styleUrls: ["./change-scenario-dialog.component.scss"],
	standalone: false,
})
export class ChangeScenarioDialogComponent
	extends BasicMaterialDialog<ChangeScenarioDialogComponent, DialogData_ChangeScenarioDialogInput, DialogData_ChangeScenarioDialogOutput>
	implements OnInit
{
	scenarioFormControl = new FormArray<FormControl<Scenario>>([], [Validators.required]);

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();

		this.scenarioFormControl.push(new FormControl(this.data.scenario));
	}

	changeScenarioClicked() {
		this.close({
			action: "ok",
			newScenario: this.scenarioFormControl.value[0],
		});
	}
}
